import { defineMessages } from "react-intl"

export default defineMessages({
  startVerification: {
    defaultMessage: "Start Verification",
    id: "src.components.WebAppPortal.VeriffIdentityVerification.startVerification",
  },

})
